/**
 * Links for non-template site pages, like landing, about, contact
 */

import React, { useContext } from 'react'
import BasicLink from '../BasicLink'
import { ConfigContext } from 'components/context/ConfigProvider'

interface PageLinkProps {
  page: string
  openInNewTab?: boolean
  className?: string
  children: React.ReactNode
}

const PageLink = ({
  page,
  openInNewTab = false,
  className,
  children,
}: PageLinkProps): JSX.Element => {
  const config = useContext(ConfigContext)

  if (!config) {
    throw new Error('Config is null or undefined from ConfigContext.')
  }

  const url = config.siteMap[page].url

  // page url should exist, throw error if not
  if (!url) {
    throw new Error(`Url not found in sitemap for page "${page}".`)
  }

  return (
    <BasicLink
      activeClassName="active"
      openInNewTab={openInNewTab}
      url={url}
      className={className}
    >
      {children}
    </BasicLink>
  )
}
export default PageLink
